/* @flow */

import Immutable from 'immutable';
import Fuse from 'fuse.js';
import extend from 'lodash/extend';
import { asyncWrapper } from './async';
import { SidePanelConstants } from '../constants/sidepanel_constants';
import { SidePanelSelectors } from './sidepanel_selectors';
import { DatasetSelectors } from './dataset_selectors';
import { ViewSelectors } from './view_selectors';
import * as APIClient from '../util/api_client';
import config from '../config';
import fuseDefaultOptions from '../data/fuse_default_options.json'

var SidePanelActionCreators = {
  setQuery: function(query: string): Function {
    return (dispatch, getState) => {
      if(query == '') {
        dispatch({
          type: SidePanelConstants.SIDEPANEL_CLEAR_SEARCH
        });
      }
      else {
        dispatch({
          type: SidePanelConstants.SIDEPANEL_LOADING_START
        });
        var collection = [];
        ViewSelectors.getSearchDatasets(getState()).forEach(datasetInfo => {
          var dataset = DatasetSelectors.getDataset(getState(), datasetInfo.get('ownerId'), datasetInfo.get('datasetId'));
          collection = collection.concat(dataset.get('features'));
        });

        const searchOptions = ViewSelectors.getSearchOptions(getState()).toJS();
        const fuseOptions = extend({}, fuseDefaultOptions, searchOptions);

        var fuse = new Fuse(collection, fuseOptions);
        var allResults = Immutable.List(fuse.search(query));

        if (allResults.size == 0) {
          dispatch({
            type: SidePanelConstants.SIDEPANEL_SET_SEARCH_RESULTS_NONE,
            query
          })
        }
        else {
          var pageResults = allResults.slice(0, config.MAX_SEARCH_RESULTS);
          dispatch({
            type: SidePanelConstants.SIDEPANEL_SET_SEARCH_RESULTS,
            query,
            allResults,
            pageResults,
            pageEnd: pageResults.size,
          });
        }

        dispatch({
          type: SidePanelConstants.SIDEPANEL_LOADING_END
        });
      };
    }
  },
  setSearchResultsPageNum: function(pageNumber: number): Function {
    return (dispatch, getState) => {
      const maxItem = pageNumber * config.MAX_SEARCH_RESULTS;
      const pageStart = maxItem - config.MAX_SEARCH_RESULTS;
      var allResults = SidePanelSelectors.getSearchResults(getState());
      var pageResults = allResults.slice(pageStart, maxItem);
      dispatch({
        type: SidePanelConstants.SIDEPANEL_UPDATE_SEARCH_PAGE,
        pageNumber,
        pageResults,
        pageStart: pageStart + 1,
        pageEnd: pageStart + pageResults.size
      });
    }
  },
  clear: function(): Object {
    return {
      type: SidePanelConstants.SIDEPANEL_CLEAR_SEARCH
    }
  },
  toggleCollapsed: function(): Object {
    return {
      type: SidePanelConstants.SIDEPANEL_TOGGLE_COLLAPSED
    }
  },
  setActiveId: function(activeId: number): Function {
    return (dispatch, getState) => {
      const searchResultPage = SidePanelSelectors.getSearchResultsPage(getState());
      const searchSuggestions = ViewSelectors.getSearchSuggestions(getState());

      if (activeId <= 0) {
        dispatch({
          type: SidePanelConstants.SIDEPANEL_SET_ACTIVEID,
          activeId: 0
        });
      }
      else if (!searchResultPage.isEmpty()) {
        if (activeId <= searchResultPage.get('results').size) {
          dispatch({
            type: SidePanelConstants.SIDEPANEL_SET_ACTIVEID,
            activeId
          });
        }
      }
      else if (activeId <= searchSuggestions.size) {
        dispatch({
          type: SidePanelConstants.SIDEPANEL_SET_ACTIVEID,
          activeId: activeId
        });
      }
    };
  },
  setSuggestionResults: function(name: string, ownerId: string, datasetId: string): Function {
    return (dispatch, getState) => {
      const dataset = DatasetSelectors.getDataset(getState(), ownerId, datasetId);
      var features = dataset.get('features');
      features.sort((a, b) => {
        if (a.id && b.id) {
          if (a.id < b.id) {
            return -1;
          }
          if (a.id > b.id) {
            return 1;
          }
          return 0;
        }
        else if (a.id) {
          return -1;
        }
        else if (b.id) {
          return 1;
        }
        return 0;
      });
      var allResults = Immutable.List(features.map((feature) => {
        return {item: feature};
      }));
      var pageResults = allResults.slice(0, config.MAX_SEARCH_RESULTS);
      dispatch({
        type: SidePanelConstants.SIDEPANEL_SET_SEARCH_RESULTS,
        query: name,
        allResults,
        pageResults,
        pageEnd: pageResults.size,
      });
    }
  }
};

export { SidePanelActionCreators };
